import classNames from 'classnames';
import * as React from 'react';
import { CustomLinkProps, Link } from '../../../../../routes';

import css from './BooksOutlineButton.module.scss';

export enum Sizing {
  Small = 'small',
}

export enum TagType {
  A = 'a',
  Button = 'button',
  Span = 'span',
  Div = 'div',
}

interface Props extends React.HTMLProps<{}> {
  href?: string;
  linkTo?: string;
  value?: number;
  onClick?: (event: React.MouseEvent) => void;
  sizing?: Sizing;
  tag?: TagType | React.ComponentType<CustomLinkProps>;
}

class BooksOutlineButton extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  private handleClick(event: React.MouseEvent) {
    const { disabled, onClick } = this.props;
    if (disabled) {
      event.preventDefault();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  }

  public render() {
    const {
      className,
      disabled,
      href,
      linkTo,
      sizing,
      value,
      tag,
      ...attr
    } = this.props;
    let Tag: React.ReactType = tag || TagType.Button;
    if (linkTo) {
      Tag = Link;
    }
    const classes = classNames(
      css.BooksOutlineButton,
      className,
      sizing === Sizing.Small ? css.isSmall : '',
    );

    return (
      <Tag
        {...attr}
        className={classes}
        disabled={disabled}
        value={value}
        onClick={this.handleClick}
      />
    );
  }
}

export default BooksOutlineButton;
